import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getLinkedFlightByKey } from "_services/linked-flight-service";

export const fetchLinkedFlight = createAsyncThunk(
    "linkedFlight/fetchByKey",
    async (flightKey) => {
        if (!flightKey) {
            throw new Error("flightKey is required");
        }
        return getLinkedFlightByKey(flightKey);
    }
);

const initialState = {
    linkedFlights: {},
};

const linkedFlightSlice = createSlice({
    name: "linkedFlight",
    initialState,
    reducers: {
        clearLinkedFlights: (state) => {
            state.linkedFlights = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLinkedFlight.pending, (state, action) => {
                const key = String(action.meta.arg);
                const existingEntry = state.linkedFlights[key];
                state.linkedFlights[key] = {
                    status: "loading",
                    data: existingEntry?.data ?? null,
                    error: null,
                };
            })
            .addCase(fetchLinkedFlight.fulfilled, (state, action) => {
                const key = String(action.meta.arg);
                state.linkedFlights[key] = {
                    status: "succeeded",
                    data: action.payload,
                    error: null,
                    fetchedAt: new Date().toISOString(),
                };
            })
            .addCase(fetchLinkedFlight.rejected, (state, action) => {
                const key = String(action.meta.arg);
                state.linkedFlights[key] = {
                    status: "failed",
                    data: state.linkedFlights[key]?.data ?? null,
                    error: action.error.message,
                };
            });
    },
});

const selectLinkedFlightEntry = (state, flightKey) => {
    if (!flightKey) return null;
    const key = String(flightKey);
    return state.linkedFlight?.linkedFlights?.[key] ?? null;
};

export const selectLinkedFlightData = (state, flightKey) =>
    selectLinkedFlightEntry(state, flightKey)?.data ?? null;

export const selectLinkedFlightStatus = (state, flightKey) =>
    selectLinkedFlightEntry(state, flightKey)?.status ?? "idle";

export const selectLinkedFlightError = (state, flightKey) =>
    selectLinkedFlightEntry(state, flightKey)?.error ?? null;

export const { clearLinkedFlights } = linkedFlightSlice.actions;

export default linkedFlightSlice.reducer;

